import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { useBranding } from "@/contexts/AgencyContext";

// Brand colors
const COLORS = {
  whatsapp: '#25D366',
  whatsappDark: '#128C7E',
};

// WhatsApp CTA link
const WHATSAPP_NUMBER = "12295882484";
const WHATSAPP_MESSAGE = encodeURIComponent("Hi, I'd love to try Fly Lite");
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

const NavBar = () => {
  const branding = useBranding();

  return (
    <nav className="fixed top-0 left-0 right-0 bg-fly-dark py-3 px-4 sm:px-6 md:px-10 flex items-center justify-between shadow-md z-50">
      <div className="flex items-center">
        <a href="/" className="flex items-center font-bold text-xl sm:text-2xl">
          {branding.logoUrl && (
            <img
              src={branding.logoUrl}
              alt={`${branding.brandName} Logo`}
              className="h-12 sm:h-14 md:h-16 mr-2"
            />
          )}
        </a>
      </div>

      {/* Hide WhatsApp CTA for white-label agencies */}
      {!branding.isWhiteLabel && (
        <div className="flex space-x-4 items-center">
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
            <Button
              className="text-white rounded-full"
              style={{
                background: `linear-gradient(135deg, ${COLORS.whatsapp} 0%, ${COLORS.whatsappDark} 100%)`,
              }}
            >
              <MessageSquare className="w-4 h-4 mr-1.5" />
              Start Free Trial
            </Button>
          </a>
        </div>
      )}
    </nav>
  );
}

export default NavBar;
